import React, { Component } from 'react'
import { Button, Alert } from 'reactstrap'
import ReactQuill from 'react-quill'
import { BeatLoader } from 'react-spinners'


class TextEditor2 extends Component {
  
  state = {
    saving: false,
    error: '',
  }

  saveIt = (val) => {
    this.setState({saving: true})
    const { save } = this.props
    save && save(val)
      .then(() => this.setState({saving: false}))
      .catch(error => this.setState({error}))
  }

  render() {
    const { saving, error, } = this.state
    const { save, } = this.props
    const { saveIt, } = this
    

    const modules = {
      formula: true,
      toolbar: [
        [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
        [{size: []}],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{'list': 'ordered'}, {'list': 'bullet'}, 
         {'indent': '-1'}, {'indent': '+1'}],
        ['link', 'image', 'video'],
        [{ 'color': [] }, { 'background': [] }],
        [{ 'script': 'sub'}, { 'script': 'super' }],
        ['clean'],
        ['formula']
      ]
    }

    return (
      <div>
        <ReactQuill 
          value={this.props.quillText} 
          onChange={this.props.handleQuillChange} 
          theme='snow'
          modules={modules}
          placeholder={'Write something...'}
        />
        {save &&
          <Button 
            onClick={() => saveIt(this.props.quillText)}
            disabled={!!saving}
          >
            {!saving && 'Save'}
            <BeatLoader loading={saving} />
          </Button>}
        {save && error && <Alert>Error saving.</Alert>}
      </div>
    )
  }
}

export default TextEditor2


// WEBPACK FOOTER //
// ./src/components/TextEditor/TextEditor2.js